module.exports = __webpack_public_path__ + "static/media/home4.8a1779c9.svg";